// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Sxb","string":"e_Txb","block":"e_Uxb","list":"e_Vxb","listItem":"e_Wxb"};